import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import {
  SchedulerFilterDto,
  columnProjectTrackerDto,
  extraColumnDto,
  extracolumnValueDto,
  filterItemDto,
  impactAssessmentSchedulerHookDto,
  navBarProjectManagmentDto,
  schedularDataDto,
  schedulerDto,
} from '../../models/Assesment-scheduler/scheduler';
import { FileType } from '../../enums/user/file-type';

@Injectable({
  providedIn: 'root',
})
export class AssesmentSchedulerService {
  constructor(private http: HttpClient) { }
  createSchedulerData(
    data: schedulerDto,
    jurisdictionId: number
  ): Observable<void> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('jurisdictionId', jurisdictionId.toString());
    return this.http.post<void>(
      `${environment.config.baseAppURL}/AssesmentScheduler/CreateSchedulerList`,
      data,
      { headers }
    );
  }
  getAllDropdownList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/AssesmentScheduler/DropdownListToAdd`,
      { headers }
    );
  }
  uploadAssesmentSchedulerAttachment(
    fileToUpload: File,
    fileType: FileType
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString());
    return this.http.post<any>(
      `${environment.config.baseAppURL}/AssesmentScheduler/UploadAssesmentSchedulerAttachment`,
      formData,
      { headers }
    );
  }
  getAllSchedulerItemList(data: filterItemDto): Observable<{ result: SchedulerFilterDto }> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<{ result: SchedulerFilterDto }>(
      `${environment.config.baseAppURL}/AssesmentScheduler/GetAllSchedulerItem`,
      data,
      { headers }
    );
  }
  getAllImpactAssessmentList(
    id: string,
    title: string,
    idList: number[]
  ): Observable<{ result: impactAssessmentSchedulerHookDto[] }> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('idList', JSON.stringify(idList));
    return this.http.get<{ result: impactAssessmentSchedulerHookDto[] }>(
      `${environment.config.baseAppURL}/AssesmentScheduler/GetImpactAssessmentSchedulerItem?Id=${id}&Title=${title}`,
      { headers }
    );
  }
  getAllSelfAssessmentList(
    jurisDictionId: number,
    id: string,
    title: string,
    idList: number[]
  ): Observable<{ result: any }> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('idList', JSON.stringify(idList));
    return this.http.get<{ result: any }>(
      `${environment.config.baseAppURL
      }/AssesmentScheduler/GetSelfAssessmentSchedulerItem?JurisDictionId=${jurisDictionId}&Id=${id.toString()}&Title=${title}`,
      { headers }
    );
  }
  getUserImpactAndSelfAssessment(
    jurisDictionId: number
  ): Observable<{ result: any }> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      ;
    return this.http.get<{ result: any }>(
      `${environment.config.baseAppURL
      }/AssesmentScheduler/GetUserImpactAndSelfAssessment?JurisDictionId=${jurisDictionId}`,
      { headers }
    );
  }
  updateSchedulerData(
    data: schedulerDto,
    jurisdictionId: number
  ): Observable<boolean> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('jurisdictionId', jurisdictionId.toString());
    return this.http.post<boolean>(
      `${environment.config.baseAppURL}/AssesmentScheduler/UpdateSchedulerList`,
      data,
      { headers }
    );
  }
  getAllProjectNameData(): Observable<{ result: columnProjectTrackerDto }> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<{ result: columnProjectTrackerDto }>(
      `${environment.config.baseAppURL}/AssesmentScheduler/GetAllProjectNameWrtColumn`,
      { headers }
    );
  }
  saveNewProjectName(
    result: columnProjectTrackerDto
  ): Observable<{ result: boolean }> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<{ result: boolean }>(
      `${environment.config.baseAppURL}/AssesmentScheduler/SaveNewProjectNameWrtColumn`,
      result,
      { headers }
    );
  }
  GetAllColumnForScheduler(
    TrackerId: number
  ): Observable<{ result: extracolumnValueDto[] }> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('TrackId', TrackerId.toString());
    return this.http.get<{ result: extracolumnValueDto[] }>(
      `${environment.config.baseAppURL}/AssesmentScheduler/GetDynamicColumnForScheduler`,
      { headers }
    );
  }
  deleteSchedulerItem(id: number): Observable<{ result: boolean }> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<{ result: boolean }>(
      `${environment.config.baseAppURL}/AssesmentScheduler/DeleteSchedulerItem?Id=${id}`,
      { headers }
    );
  }
  deleteProjectTrackerItem(id: number): Observable<{ result: boolean }> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<{ result: boolean }>(
      `${environment.config.baseAppURL}/AssesmentScheduler/DeleteProjectTrackerItem?Id=${id}`,
      { headers }
    );
  }
  getAllCalendarSchedulerItem(
    data: filterItemDto,
    month: number,
    calendarData: schedularDataDto
  ): Observable<{ result: SchedulerFilterDto }> {
    const Content = JSON.stringify(calendarData);
    let headers = new HttpHeaders()
      .set('month', month.toString())
      .set('calendarData', Content);
    return this.http.post<{ result: SchedulerFilterDto }>(
      `${environment.config.baseAppURL}/AssesmentScheduler/GetAllCalendarSchedulerItem`,
      data,

      { headers }
    );
  }
}
